import React, { Component } from 'react';
// import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Numeral from 'numeral';
import './styles.scss';

// import containerActions from '../../../../actions';
import calendar from './img/Calendar.svg';

class addCarInformation extends Component {
  constructor() {
    super();
    this.state = {

    };
  }

  render() {
    return (
      <div className="body-AddCarInf">
        <div className="title-AddCarInf">Uploading a car</div>
        <div className="description-AddCarInf">
          <span>1</span>
          <div>Description</div>
        </div>
        <div className="inputField-AddCarInf">
          <div className="rowConteiner-AddCarInf" >
            <div>Type</div>
            <input
              id="Sedan"
              checked={this.props.data.build.body_type === 'Sedan' ? 'checked' : ''}
              type="radio"
              name="group1"
              value="Sedan"
              onChange={this.props.setCarType}
            />
            <label htmlFor="Sedan" ><span />Sedan</label>
            <input
              id="VAN"
              checked={this.props.data.build.body_type === 'VAN' ? 'checked' : ''}
              type="radio"
              name="group1"
              value="VAN"
              onChange={this.props.setCarType}
            />
            <label htmlFor="VAN" ><span />VAN</label>
            <input
              id="Truck"
              checked={this.props.data.build.body_type === 'Truck' ? 'checked' : ''}
              type="radio"
              name="group1"
              value="Truck"
              onChange={this.props.setCarType}
            />
            <label htmlFor="Truck" ><span />Truck</label>
            <input
              id="SUV"
              checked={this.props.data.build.body_type === 'SUV' ? 'checked' : ''}
              type="radio"
              name="group1"
              value="SUV"
              onChange={this.props.setCarType}
            />
            <label htmlFor="SUV" ><span />SUV</label>
          </div>
          <div className="rowConteiner-AddCarInf" >
            <div>Manufacturer</div>
            <div>
              <input
                value={this.props.data.build.make}
                placeholder="Manufacturer"
                className="inputText -long"
                onChange={this.props.enterManufacturer}
              />
            </div>
          </div>
          <div className="rowConteiner-AddCarInf" >
            <div>Model</div>
            <div>
              <input
                value={this.props.data.build.model}
                placeholder="Model"
                className="inputText -long"
                onChange={this.props.enterModel}
              />
            </div>
          </div>
          <div className="rowConteiner-AddCarInf" >
            <div>Production Year<img src={calendar} alt="calendar_pic" /></div>
            <div>
              <input
                value={this.props.data.build.year}
                placeholder="2018"
                className="inputText -short"
                onChange={this.props.enterProductionYear}
              />
            </div>
          </div>
          <div className="rowConteiner-AddCarInf" >
            <div>Mileage</div>
            <div>
              <input
                // value={this.props.data.miles}
                value={this.props.data.miles === '' ? '' : Numeral(this.props.data.miles).format('0,0')}
                placeholder="0"
                className="inputText -short"
                onChange={this.props.enterMileage}
              />
              <span>km</span>
            </div>
          </div>
          <div className="rowConteiner-AddCarInf" >
            <div>Vehicle cost</div>
            <div>
              <input
                value={this.props.data.price === '' ? '' : Numeral(this.props.data.price).format('$ 0,0[.]00')}
                // value={this.props.data.price}
                placeholder="$ 0.00"
                className="inputText -mid"
                onChange={this.props.enterVehicleCost}
              />
            </div>
          </div>
          <div className="rowConteiner-AddCarInf" >
            <div>Transmission</div>
            <div>
              <select
                className="-mid"
                onChange={this.props.enterTransmission}
                value={this.props.data.build.transmission}
              >
                <option>Not specified</option>
                <option>Manual</option>
                <option>Automatic</option>
              </select>
            </div>
          </div>
          <div className="rowConteiner-AddCarInf" >
            <div>Fuel type</div>
            <div>
              <select
                className="-mid"
                onChange={this.props.enterFuelType}
                value={this.props.data.build.fuel_type}
              >
                <option>Not specified</option>
                <option>Gasoline</option>
                <option>Disel</option>
              </select>
            </div>
          </div>
          <div className="rowConteiner-AddCarInf" >
            <div>Exterior Color</div>
            <div>
              <select
                className="-mid"
                onChange={this.props.setExteriorColor}
                value={this.props.data.exterior_color}
              >
                <option />
                <option>Black</option>
                <option>Beige</option>
                <option>Blue</option>
                <option>BlueViolet</option>
                <option>Brown</option>
                <option>Cornsilk</option>
                <option>DarkBlue</option>
                <option>Gold</option>
                <option>Gray</option>
                <option>Green</option>
                <option>Olive</option>
                <option>Orange</option>
                <option>Pink</option>
                <option>Red</option>
                <option>Silver</option>
                <option>White</option>
                <option>Yellow</option>
              </select>
            </div>
          </div>
          <div className="rowConteiner-AddCarInf" >
            <div>Interior Color</div>
            <div>
              <select
                className="-mid"
                onChange={this.props.setInteriorColor}
                value={this.props.data.interior_color}
              >
                <option />
                <option>Black</option>
                <option>Beige</option>
                <option>Blue</option>
                <option>BlueViolet</option>
                <option>Brown</option>
                <option>Cornsilk</option>
                <option>DarkBlue</option>
                <option>Gold</option>
                <option>Gray</option>
                <option>Green</option>
                <option>Olive</option>
                <option>Orange</option>
                <option>Pink</option>
                <option>Red</option>
                <option>Silver</option>
                <option>White</option>
                <option>Yellow</option>
              </select>
            </div>
          </div>
          <div className="rowConteiner-AddCarInf" >
            <div>Doors</div>
            <div>
              <select
                className="-short"
                value={this.props.data.build.doors}
                onChange={this.props.setDoors}
              >
                <option>1</option>
                <option>2</option>
                <option>3</option>
                <option>4</option>
                <option>5</option>
              </select>
            </div>
          </div>
          <div className="rowConteiner-AddCarInf" >
            <div>Seating</div>
            <div>
              <select
                className="-short"
                value={this.props.data.build.std_seating}
                onChange={this.props.setSeating}
              >
                <option>1</option>
                <option>2</option>
                <option>4</option>
                <option>5</option>
                <option>7</option>
              </select>
            </div>
          </div>
          <div>
            <button
              disabled={this.props.nextButtonState}
              onClick={this.props.goToAddImmage}
              className={`nextButton -${this.props.nextButtonState ? 'true' : ''}`}
            >NEXT
            </button>
            <button onClick={this.props.closeAddCarPage} >CANCEL</button>
          </div>
        </div>
        <div className={`descriptionNext-AddCarInf -${this.props.nextButtonState ? 'true' : ''}`}>
          <span>2</span>
          <div>Upload images</div>
        </div>
      </div>
    );
  }
}

addCarInformation.propTypes = {
  setCarType: PropTypes.func.isRequired,
  enterManufacturer: PropTypes.func.isRequired,
  enterModel: PropTypes.func.isRequired,
  enterProductionYear: PropTypes.func.isRequired,
  enterMileage: PropTypes.func.isRequired,
  enterVehicleCost: PropTypes.func.isRequired,
  enterTransmission: PropTypes.func.isRequired,
  enterFuelType: PropTypes.func.isRequired,
  nextButtonState: PropTypes.bool.isRequired,
  goToAddImmage: PropTypes.func.isRequired,
  closeAddCarPage: PropTypes.func.isRequired,
  setExteriorColor: PropTypes.func.isRequired,
  setInteriorColor: PropTypes.func.isRequired,
  setDoors: PropTypes.func.isRequired,
  setSeating: PropTypes.func.isRequired,
  data: PropTypes.instanceOf(Object).isRequired
  // carsData: PropTypes.instanceOf(Object).isRequired
};


export default addCarInformation;



// WEBPACK FOOTER //
// ./src/pages/CarEditorPage/components/addCar/components/addCarInformation/index.js